'use client';

import { type Dispatch, useReducer } from 'react';

import { VideoGenerationSubmitAction, VideoGenerationSubmitState } from '../types';

export const VIDEO_GENERATION_SUBMIT_DEFAULTS: VideoGenerationSubmitState = {
    pendingTaskId: null,
    videoUrl: '',
    sourceThumbnailUrl: '',
    aiContentId: '',
    lastAiContentId: '',
    aiContentType: null,
    aiModelName: null,
    status: 'idle',
    restoredFromHistory: false,
    failureReason: null,
};

export function videoGenerationSubmitReducer(
    state: VideoGenerationSubmitState,
    action: VideoGenerationSubmitAction,
): VideoGenerationSubmitState {
    switch (action.type) {
        case 'GENERATION_IN_PROGRESS':
            if (state.status === 'inProgress' && !action.pendingTaskId) return state;
            return {
                ...state,
                status: 'inProgress',
                videoUrl: '',
                restoredFromHistory: false,
                pendingTaskId: action.pendingTaskId ?? null,
                aiContentId: action.aiContentId ?? state.aiContentId,
                lastAiContentId: action.lastAiContentId ?? state.lastAiContentId,
                aiContentType: action.aiContentType ?? state.aiContentType,
                aiModelName: action.aiModelName ?? state.aiModelName,
                failureReason: null,
            };
        case 'GENERATION_SUCCESS':
            return {
                ...state,
                videoUrl: action.videoUrl,
                aiContentId: action.aiContentId,
                lastAiContentId: action.lastAiContentId,
                aiContentType: action.aiContentType ?? state.aiContentType,
                aiModelName: action.aiModelName ?? state.aiModelName,
                restoredFromHistory: false,
                pendingTaskId: null,
                status: 'success',
                failureReason: null,
            };
        case 'GENERATION_ERROR':
            return {
                ...state,
                videoUrl: '',
                status: 'error',
                restoredFromHistory: false,
                pendingTaskId: null,
                aiContentType: null,
                aiModelName: null,
                failureReason: action.failureReason ?? null,
            };
        case 'RESET':
            return VIDEO_GENERATION_SUBMIT_DEFAULTS;
        default:
            return state;
    }
}

export function useVideoGenerationSubmit(
    initialState: VideoGenerationSubmitState = VIDEO_GENERATION_SUBMIT_DEFAULTS,
): [VideoGenerationSubmitState, Dispatch<VideoGenerationSubmitAction>] {
    return useReducer(videoGenerationSubmitReducer, initialState);
}
